import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import PropTypes from 'prop-types';
import {timeConverter} from '../../../Utils';

const ContainerComp = ({pageState}) =>{

    return <><TeacherNotificationsComp tableData={pageState.schoolNotificationData} totals={pageState.schoolData}/></>;
};

Array.prototype.removeDuplicates = function(){
    return this.reduce((result,nextItem)=>
        result.includes(nextItem) ? result : result.concat(nextItem)
    ,[]);
};

const TeacherNotificationsComp = ({tableData, totals}) => {
    const titleRow = <Row style={{fontWeight:'bold'}}>
        <Col style={{textAlign: 'left'}} xs='3'>Students</Col>
        <Col style={{textAlign: 'left'}} xs='3'>Programs</Col>
        <Col style={{textAlign: 'left'}} xs='3'>Notification</Col>
        <Col style={{textAlign: 'center'}} xs='3'>Date</Col>
    </Row>;

    return (
        <Container>
            {/* {totals.logins>1200 && <center style={{color:'red'}}>*** This summary might be incomplete, please try changing to a smaller date range ***</center>}   */}
            {tableData.map((classRec, class_i) => <span key={class_i}>
                {titleRow}
                <hr/>
                {classRec.studData.map((StudentRec, stud_i) => <span key={stud_i}>
                    <Row><Col xs='12' style={{fontWeight:'bold'}} >{StudentRec.Name}</Col></Row>
                    {StudentRec.programData.filter(programRec=>programRec.title!=='Removed Lesson').map((programRec, prog_i) => 
                        <ProgramRow key={prog_i} classRec={classRec} studentRec={StudentRec} programRec={programRec} fontWeight={'normal'}/>
                    )}
                    </span>
                )}
                </span>
            )}
        </Container>
    );
};
TeacherNotificationsComp.propTypes = {
    tableData: PropTypes.array
};

const ProgramRow = (props) => {
    const {studentRec, classRec, programRec} = props;
    const { id:progID, title, assPer, prePer, postPer, dayDate} = programRec;
    const reportCss = {
        textAlign: 'left', fontWeight: props.fontWeight, cursor:'pointer', color:'blue',textDecoration:'underline'
    };

    const showReport=(reportType)=>()=>{
        let masterLevel=classRec.classData.MasterLevel;        
        let selectedProgram = {id: progID,name:title};
        let selectedStudents = [{id:studentRec.StudentID, name: studentRec.Name}];
        let token = sessionStorage.getItem('token');

        if(reportType==='Pretest' && progID==='MMM')
            reportType = 'MMPretests';

        localStorage.setItem('reportData', JSON.stringify({
            reportType,masterLevel,
            token,
            selectedStudents,
            selectedProgram
        }));
        let newWin = window.open('/viewreports/index.html', '_blank');
        if(!newWin || !newWin.document.write || newWin.closed || typeof newWin.closed=='undefined') 
            alert('Please turn off your pop-up blocker to see the reports');
    };

    return (<>
        {assPer===100 &&
            <Row>
                <Col xs='3'></Col>
                <Col style={{textAlign: 'left', fontWeight: props.fontWeight}} xs='3'>{title}</Col>
                <Col style={{textAlign: 'left', fontWeight: props.fontWeight}} xs='3'>{'Finished Assignment'}</Col>
                <Col style={{textAlign: 'center', fontWeight: props.fontWeight}} xs='3'>{timeConverter(parseInt(dayDate))}</Col>
            </Row>}
        {prePer===100 &&
            <Row>
                <Col xs='3'></Col>
                <Col style={{textAlign: 'left', fontWeight: props.fontWeight}} xs='3'>{title}</Col>
                <Col style={reportCss} onClick={showReport('Pretest')} xs='3'> {'Finished Pre-test'}</Col>
                <Col style={{textAlign: 'center', fontWeight: props.fontWeight}} xs='3'>{timeConverter(parseInt(dayDate))}</Col>
            </Row>}
        {postPer===100 &&
            <Row>
                <Col xs='3'></Col>
                <Col style={{textAlign: 'left', fontWeight: props.fontWeight}} xs='3'>{title}</Col>
                <Col style={reportCss} onClick={showReport('Posttest')} xs='3'> {'Finished Post-test'}</Col>
                <Col style={{textAlign: 'center', fontWeight: props.fontWeight}} xs='3'>{timeConverter(parseInt(dayDate))}</Col>
            </Row>}
        </>
    );
};

ProgramRow.propTypes = {
    fontWeight: PropTypes.string,
    data: PropTypes.object
};

export default ContainerComp;
